(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-announcement')) {
    customElements.define('cm-announcement', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-cm-ann-item]')];
        if (this.items.length < 2) return;
        this.i = 0;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
        this.querySelector('[data-cm-ann-prev]')?.addEventListener('click', () => { this.go(this.i - 1); this.restart(); });
        this.querySelector('[data-cm-ann-next]')?.addEventListener('click', () => { this.go(this.i + 1); this.restart(); });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.restart());
        this.mq.addEventListener?.('change', () => this.sync());
        this.sync();
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      sync() {
        // Desktop: todos visibles e interactivos. Mobile: solo el activo.
        this.items.forEach((el, n) => {
          const hide = this.mq.matches && n !== this.i;
          el.toggleAttribute('inert', hide);
          el.setAttribute('aria-hidden', hide ? 'true' : 'false');
        });
      }
      go(n) {
        const len = this.items.length;
        this.items[this.i].classList.remove('is-active');
        this.i = (n + len) % len;
        this.items[this.i].classList.add('is-active');
        this.sync();
      }
      stop() { clearInterval(this.t); this.t = null; }
      restart() {
        this.stop();
        if (!this.delay || this.reduce) return;
        this.t = setInterval(() => { if (this.mq.matches) this.go(this.i + 1); }, this.delay);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-header')) {
    customElements.define('cm-header', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.cm-hdr');
        this.section = this.root?.parentElement;
        this.mega = this.querySelector('[data-cm-mega]');
        this.toggle = this.querySelector('[data-cm-mega-toggle]');
        this.drawer = this.root?.querySelector('[data-cm-drawer]');
        this.burger = this.querySelector('[data-cm-drawer-open]');
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.initMega();
        this.initDrawer();
        this.initSticky();
        this.setHeight();
        window.addEventListener('resize', () => this.setHeight(), { passive: true });
      }

      /* Mega menú: click/teclado + hover en dispositivos con puntero fino. */
      initMega() {
        if (!this.mega || !this.toggle) return;
        this.toggle.addEventListener('click', () => this.setMega(!this.mega.classList.contains('is-open')));
        this.mega.addEventListener('mouseenter', () => { if (this.canHover.matches) { clearTimeout(this.hoverT); this.setMega(true); } });
        this.mega.addEventListener('mouseleave', () => {
          if (!this.canHover.matches) return;
          this.hoverT = setTimeout(() => this.setMega(false), 180);
        });
        this.mega.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.mega.classList.contains('is-open')) { this.setMega(false); this.toggle.focus(); }
        });
        this.mega.addEventListener('focusout', (e) => {
          if (!this.mega.contains(e.relatedTarget)) this.setMega(false);
        });
        this.root.querySelector('[data-cm-mega-backdrop]')?.addEventListener('click', () => this.setMega(false));
      }
      setMega(open) {
        this.mega.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }

      /* Menú mobile: <dialog> modal (foco atrapado y Esc nativos). */
      initDrawer() {
        if (!this.drawer || !this.burger) return;
        this.burger.addEventListener('click', () => {
          this.drawer.showModal();
          this.burger.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
        });
        this.drawer.querySelector('[data-cm-drawer-close]')?.addEventListener('click', () => this.drawer.close());
        this.drawer.addEventListener('click', (e) => { if (e.target === this.drawer) this.drawer.close(); });
        this.drawer.addEventListener('close', () => {
          this.burger.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
          this.burger.focus({ preventScroll: true });
        });
        window.matchMedia('(min-width: 990px)').addEventListener?.('change', (e) => { if (e.matches && this.drawer.open) this.drawer.close(); });
      }

      /* Sticky "scroll-up": se oculta al bajar y reaparece al subir. */
      initSticky() {
        if (!this.section || this.root.dataset.sticky !== 'scroll-up') return;
        let last = window.scrollY;
        window.addEventListener('scroll', () => {
          const y = window.scrollY;
          if (Math.abs(y - last) < 6) return;
          const hide = y > last && y > this.section.offsetTop + this.offsetHeight * 2;
          this.section.classList.toggle('cm-hdr-is-hidden', hide);
          last = y;
        }, { passive: true });
      }

      /* Compat con Tinker: algunas secciones del tema leen --header-height. */
      setHeight() {
        document.body.style.setProperty('--header-height', this.offsetHeight + 'px');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-related"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-pdp-related')) {
    customElements.define('cm-pdp-related', class extends HTMLElement {
      connectedCallback() {
        if (this.children.length || !('IntersectionObserver' in window)) return;
        const io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('cm-pdp-related');
              if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
              else this.closest('.cm-pdp-rel')?.setAttribute('hidden', '');
            })
            .catch(() => {});
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-testimonials')) {
    customElements.define('cm-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cm-testi-track]');
        this.nav = this.querySelector('[data-cm-testi-nav]');
        this.status = this.querySelector('[data-cm-testi-status]');
        this.querySelectorAll('[data-cm-testi-filter]').forEach((btn) => {
          btn.addEventListener('click', () => this.filter(btn));
        });
        this.querySelector('[data-cm-testi-prev]')?.addEventListener('click', () => this.page(-1));
        this.querySelector('[data-cm-testi-next]')?.addEventListener('click', () => this.page(1));
        this.track?.addEventListener('scroll', () => this.updateNav(), { passive: true });
        window.addEventListener('resize', () => this.updateNav(), { passive: true });
        this.updateNav();
      }
      filter(btn) {
        const cat = btn.dataset.cmTestiFilter;
        this.querySelectorAll('[data-cm-testi-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        let n = 0;
        this.track.querySelectorAll('[data-cm-testi-cat]').forEach((card) => {
          const show = cat === 'all' || card.dataset.cmTestiCat === cat;
          card.hidden = !show;
          if (show) n++;
        });
        this.track.scrollTo({ left: 0 });
        if (this.status) this.status.textContent = n + ' testimonios';
        this.updateNav();
      }
      page(dir) {
        this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
      }
      updateNav() {
        if (!this.track || !this.nav) return;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 4;
        this.nav.hidden = !overflow;
        const [prev, next] = this.nav.querySelectorAll('button');
        prev.disabled = this.track.scrollLeft <= 2;
        next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
